<template>
  <div>
    <MarketplaceBanner />
    <ProductQuote />
    <ProductContainer />
  </div>
</template>

<script>
import MarketplaceBanner from "../components/extras/MarketplaceBanner.vue";
import ProductContainer from "../components/extras/products/ProductContainer.vue";
import ProductQuote from "../components/extras/products/ProductQuote.vue";
import { mapActions } from "vuex";
export default {
  components: {
    MarketplaceBanner,
    ProductQuote,
    ProductContainer,
  },

  data() {
    return {};
  },
  methods: {
    ...mapActions(["setCurrentPageName"]),
  },

  mounted() {
    this.$store.state.searchText = "";
    this.setCurrentPageName(this.$router.currentRoute._rawValue.name);
    console.log(this.$router.currentRoute._rawValue.name);
  },
};
</script>
